import { render, staticRenderFns } from "./NavBarAvatar.vue?vue&type=template&id=a6a8398e&scoped=true&"
import script from "./NavBarAvatar.vue?vue&type=script&lang=js&"
export * from "./NavBarAvatar.vue?vue&type=script&lang=js&"
import style0 from "./NavBarAvatar.vue?vue&type=style&index=0&id=a6a8398e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a8398e",
  null
  
)

export default component.exports